module.exports = __webpack_public_path__ + "images/bannerFR-4b26bedeeca7bc606bd1b7800119265a.png";